var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 24c5.523 0 10-4.477 10-10S29.523 4 24 4 14 8.477 14 14s4.477 10 10 10m7 2.5h-1.305A13.6 13.6 0 0 1 24 27.75c-2.031 0-3.953-.453-5.695-1.25H17c-5.797 0-10.5 4.703-10.5 10.5v3.25c0 2.07 1.68 3.75 3.75 3.75h27.5c2.07 0 3.75-1.68 3.75-3.75V37c0-5.797-4.703-10.5-10.5-10.5"
  })));
};
export default SvgIconUser;